import React, { Component } from 'react';

import ReadyToJoin from './ReadyToJoin/ReadyToJoin';

//import ScrollContainer from '@components/ScrollContainer/ScrollContainer';

import Helmet from 'react-helmet';

class NovemberPromotions extends Component {
  state = {
    modalActive: false
  };

  toggleModal = () => {
    const current = this.state.modalActive;
    this.setState({
      modalActive: !current
    });
  };

  render() {
    let height = window.innerHeight;

    const readyToJoinProps = {
      screenHeight: height,
      className: 'panel align-items-center'
    };

    /*const scrollContainerProps = {
      pageHeight: height,
      active: window.location.pathname === '/suitekey-membership/join' ? 3 : 0
    };*/

    return (
      <React.Fragment>
        <Helmet>
          <title>November Promotions | JetSuite</title>
          <meta name="description" content={'November Promotions'} />
        </Helmet>

        <ReadyToJoin {...readyToJoinProps} />
      </React.Fragment>
    );
  }
}

export default NovemberPromotions;



// WEBPACK FOOTER //
// ./src/components/NovemberPromotions/NovemberPromotions.jsx